import { Component } from '@angular/core';
import { MatModule } from '../appModules/mat.module';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-staff-account-creation',
  imports: [CommonModule, MatModule, ReactiveFormsModule, FormsModule, MatInputModule, MatSelectModule, MatButtonModule, MatCardModule, MatFormFieldModule ],
  templateUrl: './staff-account-creation.component.html',
  styleUrl: './staff-account-creation.component.scss'
})
export class StaffAccountCreationComponent {
  staffForm!: FormGroup;

  desigations: string[] = [
    'HOD',
    'Professor',
  ];

  courses: string[];

  constructor(private fb: FormBuilder, private api: ApiService, private common: CommonService, private router: Router) {}

  fetch_courses(){
    this.api.get('courses/list').subscribe( resp => {
      if(resp.success){
        this.courses = resp.data;
      }
    })
  }

  ngOnInit(): void {
    this.staffForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.pattern(/^[a-zA-Z\s]+$/)]],
      staffId: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      designation: ['', Validators.required],
      staffCourse: [[], [Validators.required, this.minSelectedArray(1)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.minLength(6),
        Validators.pattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])/)
      ]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });

    this.fetch_courses();
  }


  passwordMatchValidator(form: AbstractControl) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ mismatch: true });
    } else {
      form.get('confirmPassword')?.setErrors(null);
    }
    return null;
  }

  get f(): { [key: string]: AbstractControl } { return this.staffForm.controls; }

  minSelectedArray(min: number) {
    return (control: AbstractControl) => {
      const value = control.value || [];
      return value.length >= min ? null : { minSelected: true };
    };
  }

  onSubmit() {
    if (this.staffForm.invalid) {
      this.staffForm.markAllAsTouched();
      return;
    }
  
    const { confirmPassword, password, ...formDataWithoutPasswords } = this.staffForm.value;
  
    const payload = {
      ...formDataWithoutPasswords,
      password: password // Only include password for backend
    };
  
    this.api.post('user/staff_account_creation', payload).subscribe(
      resp => {
        if (resp && resp.success) {
          this.common.notification(resp.message);
        } else {
          this.common.notification(resp.message, true);
        }
        this.router.navigate(['/staff-list'])
      },
      error => {
        console.error('Error submitting form:', error);
      }
    );
  
    console.log('Form Data (excluding passwords):', formDataWithoutPasswords);
  }
  

  onReset() {
    this.staffForm.reset();
  }

}
